import { render, staticRenderFns } from "./price.vue?vue&type=template&id=700255fe"
import script from "./price.vue?vue&type=script&lang=ts"
export * from "./price.vue?vue&type=script&lang=ts"
import style0 from "./price.vue?vue&type=style&index=0&id=700255fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports